<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="contents" title="Table of Contents">
<p class="h2a"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Table of Contents</span></p>
<p class="toc" id="intro"><a href="#/text/Introduction#aintro"><span class="small">INTRODUCTION</span></a></p>
<p class="toc"><a href="#/text/Introduction#aintro">On the Road</a></p>
<p class="toc2" id="ch1"><a href="#/text/Chapter01#ach1"><span class="small">CHAPTER ONE</span></a></p>
<p class="toc"><a href="#/text/Chapter01#ach1">The Work Enslaves Us</a></p>
<p class="toc2" id="ch2"><span href="#/text/Chapter02#ach2" title="Link target outside of Sample"><span class="small">CHAPTER TWO</span></span></p>
<p class="toc"><span href="#/text/Chapter02#ach2" title="Link target outside of Sample">SITRATERCO: Women’s Power Is Union Power</span></p>
<p class="toc2" id="ch3"><span href="#/text/Chapter03#ach3" title="Link target outside of Sample"><span class="small">CHAPTER THREE</span></span></p>
<p class="toc"><span href="#/text/Chapter03#ach3" title="Link target outside of Sample">Honduras: A Free Space</span></p>
<p class="toc2" id="ch4"><span href="#/text/Chapter04#ach4" title="Link target outside of Sample"><span class="small">CHAPTER FOUR</span></span></p>
<p class="toc"><span href="#/text/Chapter04#ach4" title="Link target outside of Sample">Latin America: The Big Challenge</span></p>
<p class="toc2" id="ch5"><span href="#/text/Chapter05#ach5" title="Link target outside of Sample"><span class="small">CHAPTER FIVE</span></span></p>
<p class="toc"><span href="#/text/Chapter05#ach5" title="Link target outside of Sample">The War at Home</span></p>
<p class="toc2" id="ch6"><span href="#/text/Chapter06#ach6" title="Link target outside of Sample"><span class="small">CHAPTER SIX</span></span></p>
<p class="toc"><span href="#/text/Chapter06#ach6" title="Link target outside of Sample">Global Allies</span></p>
<p class="toc2" id="con"><span href="#/text/Conclusion#acon" title="Link target outside of Sample"><span class="small">CONCLUSION</span></span></p>
<p class="toc"><span href="#/text/Conclusion#acon" title="Link target outside of Sample">A New Kind of Labor Movement</span></p>
<p class="toct" id="notes"><span href="#/text/Notes#anotes" title="Link target outside of Sample">Notes</span></p>
<p class="toc" id="index"><span href="#/text/Index#aindex" title="Link target outside of Sample">Index</span></p>
<p class="toc" id="author"><span href="#/text/Author#aauthor" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?19a80e70